import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.Brainstorm,
  voices: {
    main: {
      description:
        "brilliant mutant scholar baritone, measured intellectual cadence, warm authority over psychic pressure, clean lecture-hall projection, subtle cerebral hum",
      seed: 10793,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      { id: "select_1", text: "Wind, cloud, and storm, hear my command!" },
      { id: "select_2", text: "Someone prayed for a Goddess?" },
      { id: "select_3", text: "Wind and thunder are by your side." },
      { id: "select_4", text: "Here comes the Goddess!" },
    ],
    spawn: [
      { id: "spawn_1", text: "The forecast calls for thunder!" },
      { id: "spawn_2", text: "God and Goddess, united by thunder!" },
      { id: "spawn_3", text: "May the rains bless us and heal us…" },
      { id: "spawn_4", text: "Prepare to ride the winds, my aquatic friend!" },
      {
        id: "spawn_5",
        text: "If these worlds come apart, countless people will die. I must stop it.",
      },
      {
        id: "spawn_6",
        text: "In times like these, people with power must be at their best.",
      },
      {
        id: "spawn_7",
        text: "Billions of people are counting on us to put the timelines back where they belong.",
      },
      {
        id: "spawn_8",
        text: "Whatever happened to the world, I am going to help fix it.",
      },
      {
        id: "spawn_9",
        text: "I can feel the currents and electricity in my veins.",
      },
      {
        id: "spawn_10",
        text: "You don't have to be humble to be a hero. I'm not.",
      },
      {
        id: "spawn_11",
        text: "Krakoa brought mutants together. So here we must make our stand.",
      },
      {
        id: "spawn_12",
        text: "Doom — both Dooms — will answer for their crimes.",
      },
      {
        id: "spawn_13",
        text: "Crossed timelines make for strange allies. Who do we trust?",
      },
      { id: "spawn_14", text: "Mutant or human, I fight for EVERYONE." },
      { id: "spawn_15", text: "I am a Mutant, and proud to be one." },
      {
        id: "spawn_16",
        text: "Power is a great gift. It must be used wisely.",
      },
      {
        id: "spawn_17",
        text: "I have been a street urchin, and Regent of the Solar System. But I am always Ororo.",
      },
      {
        id: "spawn_18",
        text: "When you have been powerless, having power means something.",
      },
      {
        id: "spawn_19",
        text: "Mutants must protect Mutants…but also all of humanity.",
      },
      {
        id: "spawn_20",
        text: "Somewhere in the world is a little girl like I once was. I fight for her.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "You can't strike down a goddess." },
      { id: "respawn_2", text: "The wind will only blow stronger." },
      { id: "respawn_3", text: "I will not make the same mistakes again." },
      { id: "respawn_4", text: "Now the thunder is coming!" },
      { id: "respawn_5", text: "A storm is brewing…" },
      { id: "respawn_6", text: "Brainstorm is rising again…" },
      { id: "respawn_7", text: "Brainstorm clouds gather…" },
      { id: "respawn_8", text: "This Brainstorm never truly ends." },
    ],
    ult_ally: [{ id: "ult_ally", text: "Hurricane incoming!" }],
    ult_enemy: [{ id: "ult_enemy", text: "Feel the wrath of the Goddess!" }],
    ability2: [
      { id: "ability2_1", text: "Speed is everything." },
      { id: "ability2_2", text: "Ride the winds!" },
      { id: "ability2_3", text: "Let's end this quick." },
      { id: "ability2_4", text: "You're in my storm." },
      { id: "ability2_5", text: "Thunderbolt!" },
      { id: "ability2_6", text: "Thunder strike!" },
    ],
    ability1: [
      { id: "ability1_1", text: "Faster, my friends!" },
      { id: "ability1_2", text: "Be swift." },
      { id: "ability1_3", text: "Have a tailwind." },
      { id: "ability1_4", text: "I bring thunder!" },
      { id: "ability1_5", text: "Be strong." },
      { id: "ability1_6", text: "Feel the thunder!" },
    ],
    kill: [
      { id: "kill_1", text: "You rode the lightning." },
      { id: "kill_2", text: "No pleasure in that, but it had to be done." },
      { id: "kill_3", text: "You're mine." },
      { id: "kill_4", text: "Good hunting." },
      { id: "kill_5", text: "Go with the wind." },
      { id: "kill_6", text: "You're thunderstruck!" },
      { id: "kill_7", text: "Blew them away." },
      { id: "kill_8", text: "Couldn't stand the weather." },
    ],
    multikill: [
      { id: "multikill_1", text: "Triple strike!" },
      { id: "multikill_2", text: "Three! A little streak." },
      { id: "multikill_3", text: "Lucky three!" },
      { id: "multikill_4", text: "Five! That's some chain lightning." },
      { id: "multikill_5", text: "Five straight!" },
      { id: "multikill_6", text: "Five? I had lost count." },
      { id: "multikill_7", text: "Am I making you all jealous?" },
      {
        id: "multikill_8",
        text: "Don't feel bad. Not everyone can be Brainstorm.",
      },
      { id: "multikill_9", text: "No one escapes the weather." },
    ],
    low_hp: [
      { id: "low_hp_1", text: "I feel strong again!" },
      { id: "low_hp_2", text: "Good as new!" },
    ],
    healed: [
      { id: "healed_1", text: "A timely boost!" },
      { id: "healed_2", text: "Any healing is good healing." },
      { id: "healed_3", text: "I feel new strength." },
      { id: "healed_4", text: "Freshly energized!" },
    ],
  },
} satisfies VoiceScript;

export default script;
